import { useQuery } from '@tanstack/react-query';
import { request } from 'javascripts/services/v3ApiClient';
import type {
  V3ApiSuccessData,
  V3ApiError,
} from 'javascripts/services/v3ApiClient';
import { type GooglePlacesAutocomplete } from 'data/v3/data-contracts';

type GooglePlacesAutocompleteResponse =
  V3ApiSuccessData<GooglePlacesAutocomplete>;

export const useGooglePlacesAutocomplete = (
  query: string,
  primaryType?: string,
) => {
  return useQuery<GooglePlacesAutocompleteResponse, V3ApiError>({
    queryFn: async () => {
      const response = await request({
        url: `/google_places?query=${query}&primary_type=${primaryType}`,
      });
      return response.data;
    },
    queryKey: ['googlePlacesAutocomplete', query],
    enabled: query.length >= 3,
  });
};
